/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventRaffleHistoryListRequest model module.
 * @module model/EventsControllerDtoEventRaffleHistoryListRequest
 * @version 1.0
 */
class EventsControllerDtoEventRaffleHistoryListRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventRaffleHistoryListRequest</code>.
     * @alias module:model/EventsControllerDtoEventRaffleHistoryListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        EventsControllerDtoEventRaffleHistoryListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>EventsControllerDtoEventRaffleHistoryListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventRaffleHistoryListRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventRaffleHistoryListRequest} The populated <code>EventsControllerDtoEventRaffleHistoryListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventRaffleHistoryListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('raffleNo')) {
                obj['raffleNo'] = ApiClient.convertToType(data['raffleNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventRaffleHistoryListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventRaffleHistoryListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of EventsControllerDtoEventRaffleHistoryListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

EventsControllerDtoEventRaffleHistoryListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
EventsControllerDtoEventRaffleHistoryListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
EventsControllerDtoEventRaffleHistoryListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
EventsControllerDtoEventRaffleHistoryListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} raffleNo
 */
EventsControllerDtoEventRaffleHistoryListRequest.prototype['raffleNo'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventRaffleHistoryListRequest.prototype['accountNo'] = undefined;






export default EventsControllerDtoEventRaffleHistoryListRequest;

